// extracted by mini-css-extract-plugin
module.exports = {"root":"Campaign_root__1AwJd","labelName":"Campaign_labelName__9DOrK","labelDate":"Campaign_labelDate__1WtcR","labelPhase":"Campaign_labelPhase__DX0rJ"};